import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_STUDENTS, 
    ADD_NEW_STUDENT, 
    UPDATE_STUDENT, 
    DELETE_STUDENT,
    GET_STUDENT_BY_UUID
} from "./actionTypes";
import {
    getStudentsSuccess,
    getStudentsFail,
    addStudentSuccess,
    addStudentFail,
    updateStudentSuccess,
    updateStudentFail,
    deleteStudentSuccess,
    deleteStudentFail,

    getStudentByUuidSuccess,
    getStudentByUuidFail,
   

   
} from "./actions"

import {
    getStudents,
    addNewStudent,
    updateStudent,
    deleteStudent,
    getStudentByUuid,
   
} from "helpers/students/students_backend_helper";
import { toast } from "react-toastify";

/*
function* fetchStudents() {
    try {
        const response = yield call(getStudents)
        yield put(getStudentsSuccess(response))
    } catch (error) {
        yield put(getStudentsFail(error))
    }
}
*/

function* fetchStudents({ payload }) {
  try {
    // payload = filters envoyés depuis le composant
    const response = yield call(getStudents, payload || {});
    yield put(getStudentsSuccess(response));
  } catch (error) {
    yield put(getStudentsFail(error));
  }
}

function* onAddNewStudent({ payload }) {
    try {

        
        const response = yield call(addNewStudent, payload)

        console.log("RESPONSE:", response);
        yield put(addStudentSuccess(response.student))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(addStudentFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* onUpdateStudent({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateStudent, payload)
        yield put(updateStudentSuccess(response.student))
        toast.success(response.data.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateStudentFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteStudent({ payload: data }) {

    try {
        const response = yield call(deleteStudent, data)
        yield put(deleteStudentSuccess(response.studentId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteStudentFail(error))
        toast.error("Branch  Deleted Failed", { autoClose: 2000 });
    }
}

function* onGetStudentByUuid({ payload }) {
  try {
    const response = yield call(getStudentByUuid, payload);
    console.log("STUDENT BY UID:", response);
    yield put(getStudentByUuidSuccess(response));
  } catch (error) {
    yield put(getStudentByUuidFail(error));
  }
}


function* studentSaga() {
    yield takeEvery(GET_STUDENTS, fetchStudents)
    yield takeEvery(ADD_NEW_STUDENT, onAddNewStudent)
    yield takeEvery(UPDATE_STUDENT, onUpdateStudent)
    yield takeEvery(DELETE_STUDENT, onDeleteStudent)
    yield takeEvery(GET_STUDENT_BY_UUID, onGetStudentByUuid)
}

export default studentSaga;